import api from './api'
import {
  DocumentoElegivelReuso,
  DocumentoReaproveitado,
  ReaproveitarDocumentoRequest,
} from '@/types/documentoReuso'

const BASE_URL = '/api/v1/documentos'

/**
 * Reuso de documentos por CNPJ (Q42, Onda 3 L1). A tela nunca copia referência de documento:
 * pede ao servidor os elegíveis da reserva (só marcadores, para documentos de outra
 * carteira) e devolve o marcador para o servidor reaproveitar — que confere tudo de novo.
 */
export const documentoReusoService = {
  /** Elegíveis para a reserva de destino (CNPJ e tenant vêm da própria reserva). */
  elegiveis: async (reservaId: string, tipos?: string[]): Promise<DocumentoElegivelReuso[]> => {
    const params = new URLSearchParams()
    for (const t of tipos ?? []) params.append('tipos', t)
    const qs = params.toString()
    return await api.get<DocumentoElegivelReuso[]>(
      `${BASE_URL}/reuso/reserva/${reservaId}${qs ? `?${qs}` : ''}`
    )
  },

  /** 409 `REUSO_NAO_AUTORIZADO` = sem autorização: a tela pede novo envio. */
  reaproveitar: async (pedido: ReaproveitarDocumentoRequest): Promise<DocumentoReaproveitado> => {
    return await api.post<DocumentoReaproveitado>(`${BASE_URL}/reuso`, pedido)
  },
}
